import { GET_PRODUCTS, ADDTOCARD_LIST, GET_LISTOFORDER, GET_PRODUCTS_FORDECORE, GET_GROCERY_PRODUCTS, ADDTOCARD_GROCERY_LIST, GET_ACCESSKEYS } from '../action'
var initialState = 
    {
    products: null,
    loading: false,
    error: null
    }
    // [{
    //     userName: "kunal",
    //     email: "triokzz0@gmail.com"
    // }]
const allProducts = (state = { initialState }, action) => {
    switch (action.type) {

        case 'GET_PRODUCTS_LOADING':
        return { ...state, loading: true, error: null };

        case GET_PRODUCTS:
            return {
                ...state,
                user: action.payload,
                loggedIn: true
            };


            case 'GET_PRODUCTS_ERROR':
                return { ...state, loading: false, error: action.payload };

        case GET_GROCERY_PRODUCTS:
            return {
                ...state,
                grocery: action.payload,
                loggedIn: true
            };

        case GET_PRODUCTS_FORDECORE:
            return {
                ...state,
                decoreuser: action.payload,
                loggedIn: true
            };

        case ADDTOCARD_LIST:
            return {
                ...state,
                order: action.payload,
                loggedIn: true
            };
        case ADDTOCARD_GROCERY_LIST:
            return {
                ...state,
                order: action.payload,
                loggedIn: true
            };
        case GET_LISTOFORDER:
            return {
                ...state,
                listoforder: action.payload,
                loggedIn: false
            }
            case GET_ACCESSKEYS:
                return {
                    ...state,
                    access: action.payload,
                    loggedIn: true
                }
        default:
            return state;
    }
};

export default allProducts;